module.exports = __webpack_public_path__ + "static2024-7-11/img/sun.099dfa56.png";